import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2aa24ead"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full flex flex-col items-center justify-center ml-auto mr-auto w-full md:justify-between md:flex-row xl:w-1200px" }
const _hoisted_2 = ["href", "target"]
const _hoisted_3 = { class: "flex flex-row items-center justify-end w-full md:w-auto" }
const _hoisted_4 = { class: "h-40 w-1/2 md:h-72 flex flex-col items-center justify-center right-1 md:w-52 md:right-7 relative" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]

import { ref, computed } from 'vue'
import { onMounted } from '@vue/runtime-core'
import headerImgUrl from '../images/header.jpeg'
import headerMobileImgUrl from '../images/header-mobile-back.png'
import ethCombilePng from '../images/eth-combine.png'
import arCombilePng from '../images/ar-combine.png'
import warCombilePng from '../images/war-combine.png'
import { useI18n } from 'vue-i18n'
import { isProd, isMobile } from '../constants'

// eslint-disable-next-line no-unused-vars

export default /*#__PURE__*/_defineComponent({
  props: {
    scrollTop: null
  },
  setup(__props: any) {

const props = __props as {
  scrollTop: number,
}



const { t, locale } = useI18n()
const windowWidth = ref(document.documentElement.offsetWidth)
const headerBackUrl = computed(() => {
  return windowWidth.value < 768 ? headerMobileImgUrl : headerImgUrl
})
const headerHeight = computed(() => {
  return windowWidth.value < 768 ? (windowWidth.value / 750 * 1056) : (windowWidth.value / 3360 * 1434)
})
const host = isProd ? 'https://app.everpay.io' : 'https://app-dev.everpay.io'

onMounted(() => {
  window.addEventListener('resize', () => {
    windowWidth.value = document.documentElement.offsetWidth
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: "px-5 w-full bg-no-repeat bg-center bg-contain",
    style: _normalizeStyle(`height: ${_unref(headerHeight)}px;background-image:url(${_unref(headerBackUrl)});`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-col items-center justify-center md:mb-0 md:items-start md:h-full md:mt-0", _unref(locale) === 'en' ? 'mt-16 mb-8' : 'mt-28 mb-24'])
      }, [
        _createElementVNode("h1", {
          class: _normalizeClass(["text-4xl text-center mb-6 md:text-left md:text-5xl md:mb-8 lg:text-6xl", _unref(locale).includes('zh') ? 'md:w-full' : 'md:w-2/3'])
        }, _toDisplayString(_unref(t)('slogan')), 3),
        _createElementVNode("a", {
          href: _unref(host),
          target: !_unref(isMobile) ? '_blank' : '',
          class: "connect-btn text-base px-5 py-2 cursor-pointer text-white"
        }, _toDisplayString(_unref(t)('launch_app')), 9, _hoisted_2)
      ], 2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            class: "h-6 md:h-10 absolute top-0 left-10 md:top-2 md:left-0 combile-png combile-eth",
            src: _unref(ethCombilePng)
          }, null, 8, _hoisted_5),
          _createElementVNode("img", {
            class: "h-6 md:h-10 relative left-12 md:left-6 combile-png combile-ar",
            src: _unref(arCombilePng)
          }, null, 8, _hoisted_6),
          _createElementVNode("img", {
            class: "h-6 md:h-10 absolute bottom-2 right-0 combile-png combile-war",
            src: _unref(warCombilePng)
          }, null, 8, _hoisted_7)
        ])
      ])
    ])
  ], 4))
}
}

})